import { render, staticRenderFns } from "./StkScLDefault_List.vue?vue&type=template&id=19884fd6"
import script from "./StkScLDefault_List.vue?vue&type=script&lang=js"
export * from "./StkScLDefault_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports